module.exports = __webpack_public_path__ + "static/media/icons_Bilan r‚habilitation respiratoire.3fb3c3b1.svg";